// pages/BookingPayment.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import packageJson from "../../package.json";

const BASE_URL = packageJson.apiUrl;
const stripePromise = loadStripe("pk_live_51RJWTaGb7gg2VKZUq0FQVLsfinuBMckTYcgYIxSGYvOBk8FxxbPbCGLL8rfr7eS3lx4hUXjTPFW2NWvLeTcqmgq100pwsblqnd"); // replace with your Stripe publishable key

const BookingPayment = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const { id } = useParams();

  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const tokenKey = sessionStorage.getItem("bookingToken");

  // ✅ Fetch course by slug
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/course/${id}`);
        let courseData = null;
        if (res.data.course) courseData = res.data.course;
        else if (res.data.data) courseData = res.data.data;
        else if (res.data.id) courseData = res.data;

        setCourse(courseData);
        console.log("✅ Fetched course for payment:", courseData);
      } catch (err) {
        console.error("❌ Error fetching course:", err);
      }
    };
    fetchCourse();
  }, [id]);

  const handlePayment = async (e) => {
    e.preventDefault();
    if (!stripe || !elements || !course) return;

    try {
      setLoading(true);

      // Create payment intent
      const res = await fetch(`${BASE_URL}/inhouse/create-payment-intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token_unique_key: tokenKey,
          amount: course.price * 100,
          currency: "GBP",
        }),
      });
      const data = await res.json();
      if (!data.clientSecret) throw new Error("Payment intent failed");

      const cardElement = elements.getElement(CardElement);
      const { paymentIntent, error } = await stripe.confirmCardPayment(data.clientSecret, {
        payment_method: { card: cardElement },
      });

      if (error) {
        setStatus("Payment failed: " + error.message);
        navigate("/failed");
        return;
      }

      if (paymentIntent.status === "succeeded") {
        await fetch(`${BASE_URL}/inhouse/payment-success`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            token_unique_key: tokenKey,
            transaction_id: paymentIntent.id,
            amount: course.price * 100,
            payment_data: paymentIntent,
          }),
        });

        setStatus("Payment successful!");
        navigate("/success");
      }
    } catch (err) {
      setStatus("Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!course) {
    return <p style={{ textAlign: "center" }}>Loading course details...</p>;
  }

  return (
    <section className="section-space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4">
            <div class="login-box">
              <div className="login-left">
                <form onSubmit={handlePayment} >
                  <h3 className="login-title">Step 3: Payment</h3>
                  <p style={{ textAlign: "center", fontSize: "18px", marginBottom: "25px" }}>
                    <strong>Course:</strong> {course?.name || "Course"} <br />
                    <strong>Price:</strong> £{course.price}
                  </p>
                  <CardElement style={{ base: { fontSize: "16px" } }} />
                  <button
                    type="submit"
                    disabled={loading || !stripe}
                   className="btn btn-green w-100"
                  >
                    {loading ? "Processing..." : `Pay £${course.price}`}
                  </button>
                  {status && <p style={{ marginTop: "15px", textAlign: "center", color: status.includes("success") ? "green" : "red" }}>{status}</p>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default function BookingPaymentWrapper() {
  return (
    <Elements stripe={stripePromise}>
      <BookingPayment />
    </Elements>
  );
}
